import { createServerOnlyFn } from "@tanstack/react-start";
import { forwardLegacyOperation } from "./index.server.ts";

const handleLegacyOperation = createServerOnlyFn(
    ({ request }: { request: Request }) => forwardLegacyOperation(request),
);

export const legacyPostRoute = {
    server: { handlers: { POST: handleLegacyOperation } },
};
export const legacyReadWriteRoute = {
    server: {
        handlers: { GET: handleLegacyOperation, POST: handleLegacyOperation },
    },
};
